import styled from 'styled-components'

const ReportSummaryPercentIndicatorInfoItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  justify-content: space-between;
`

export default ReportSummaryPercentIndicatorInfoItem